var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Gift50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M38,42H10c-1.1,0-2-0.9-2-2V18h32v22C40,41.1,39.1,42,38,42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M42,20H6v-6c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2V20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8f00",
    d: "M22,20h4v22h-4V20z M32,6h-4l-6,6h4L32,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M20,6h-4l6,6v8h4v-8L20,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Gift50);
export default __webpack_public_path__ + "static/media/icons8-gift-50.754a271f28a979b3800bb99fd6ed84de.svg";
export { ForwardRef as ReactComponent };